import './index.scss'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import  ResetAttributes  from '../../../general/ResetButton.js'

import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { useSelect, useDispatch } from '@wordpress/data';

import { InspectorControls } from '@wordpress/block-editor';
import {	
	PanelBody,	 
	RangeControl, 
	SelectControl,
	Flex,
	FlexItem, 	
	TextControl,
	Button,
	ButtonGroup,
	ToggleControl
} from '@wordpress/components';


const allowedBlocks = [ 'core/group' ];
const units = ['','px', 'em', 'rem', '%', 'vh', 'vw'];
const adimensionDefaults = {
	aOn: false,
	width: ['',''],
	height: ['',''],
	marginTopList: ['','',''],
};


const addAttributes = ( settings, name ) => {		
	if ( !allowedBlocks.includes( name ) ) return settings;

	if(typeof settings.attributes !== 'undefined') {		
		settings.attributes = {
			...settings.attributes,
			adimension: {
				type: 'object',
				default: adimensionDefaults
			} 
		}		 
	}
	return settings;
}


const addInspectorControl = (BlockEdit) => (props) => {
	
	if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

	const {	name,	attributes,	setAttributes, isSelected	} = props;
	const {	adimension = {} } = attributes;

	const orgDefaults = {
		...adimensionDefaults,
		...(attributes.adimension || {}),
	};

	const {
		aOn,
		width, 
		height, 
		marginTopList
	} = orgDefaults;

	const isDifferentFromDefault = JSON.stringify({ ...adimension }) !== JSON.stringify({ ...adimensionDefaults });

	const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
	const updateArray = (list, index, newVal) => {
		const listsCopy = [...list];
		listsCopy[index] = newVal;
		return listsCopy;
	}

	const reset = () => {
		setAttributes({ 
			adimension: { 
				...adimension, 
				marginTopList: ['', '', ''] 
			} 
		});		
	}

	const [syncViewport, setSyncViewport] = useState(false);
	const [breakPoint, setBreakPoint] = useState(0);

	useEffect(() => {
		const update = () => {
			let temp = 'Desktop';
			if (breakPoint === 1) temp = 'Tablet';
			if (breakPoint === 2) temp = 'Mobile';
			if (syncViewport) wp.data.dispatch('core/editor').setDeviceType(temp);
		};
		update();
	}, [syncViewport, breakPoint]);


	
	return (
		<>
			<BlockEdit { ...props } />

			<InspectorControls group="styles">			
		
				<PanelBody title={ __( 'Dimension', 'aver' ) } initialOpen={ aOn }>
					<Flex direction="column">
						<Flex>
							<FlexItem>
								<ToggleControl
									label={__('Enable Dimension', 'aver')}
									checked={aOn}
									onChange={(val) => setAttributes({ adimension: {...adimension, aOn: val }})}
								/>
							</FlexItem>
							<FlexItem>
								{ isDifferentFromDefault && (
									<ResetAttributes
										onConfirm={() => {
											setAttributes({
												adimension: adimensionDefaults
											});								
										}}
									/> 
								)}
							</FlexItem>
						</Flex>		

						{ aOn && ( <>
						<Flex>
							<FlexItem flexGrow="1">
								<TextControl
									label={__(`Width`, 'aver')}
									value={ width[0] }
									type="number"
									onChange={ ( newval ) => {
											setAttributes({ adimension: {...adimension, width: updateArray(width, 0, newval)}})												
									}	}									
								/>
							</FlexItem>
							<FlexItem>
								<SelectControl
									label="Unit"
									value={ width[1]}
									options={ units.map( u => ({ label: u, value: u })) }
									onChange={ ( newval ) => { 
										setAttributes({ adimension: {...adimension, width: updateArray(width, 1, newval)}})		  
									} } 
								/>
							</FlexItem>
						</Flex>		

						<Flex>
							<FlexItem>
								<TextControl									
									label={__(`Height`, 'aver')}
									value={ height[0] }
									type="number"
									onChange={ ( newval ) => {
											setAttributes({ adimension: {...adimension, height: updateArray(height, 0, newval)}})												
									}	}									
								/>
							</FlexItem>
							<FlexItem>
								<SelectControl
									label="Unit"
									value={ height[1]}
									options={ units.map( u => ({ label: u, value: u })) }
									onChange={ ( newval ) => { 
										setAttributes({ adimension: {...adimension, height: updateArray(height, 1, newval)}})		  
									} } 
								/>
							</FlexItem>
						</Flex>				
				
						<Flex>
							<FlexItem className="button-frame">
								<Button icon="welcome-view-site" label="Sync Viewport" onClick={() => setSyncViewport(!syncViewport)}	isPressed={syncViewport} />
								<Button icon="undo"	label="Reset All"	onClick={reset}	/>
							</FlexItem>
							<FlexItem className="button-frame">
								<Button	icon="desktop" isPressed={breakPoint === 0}	onClick={() => setBreakPoint(0)} label=">1024px" />
								<Button icon="tablet"	isPressed={breakPoint === 1} onClick={() => setBreakPoint(1)}	label="≥782px" />
								<Button	icon="smartphone"	isPressed={breakPoint === 2} onClick={() => setBreakPoint(2)}	label="<782px"/>
							</FlexItem>
						</Flex>
				
						<RangeControl
							beforeIcon="arrow-left-alt2"
							afterIcon="arrow-right-alt2"
							label={__(`Margin Top(px)[${breakPoint}]`, 'aver')}
							min={-1440}
							max={1440}
							value={marginTopList[breakPoint]}
							onChange={(newVal) =>
								setAttributes({
									adimension: {
										...adimension,
										marginTopList: updateArray(marginTopList, breakPoint, newVal),
									},
								})
							}
						/>
						</> )}
					</Flex>		
				</PanelBody>
			</InspectorControls>					

		</>
	)
}



const applyExtraClassEditor = ( BlockListBlock ) => ( props ) => {

	if (!allowedBlocks.includes(props.name)) return <BlockListBlock {...props} />	

	const { attributes, wrapperProps, className } = props;
	const { adimension = {} } = attributes;
	const orgDefaults = {
		...adimensionDefaults,
		...(attributes.adimension || {}),
	};

	const {
		aOn,
		width, 
		height, 
		marginTopList
	} = orgDefaults;


	const currentDevice = useSelect((select) => {
			return select( 'core/editor' ).getDeviceType();
		}, []);
	const breakPoint = { Desktop: 0, Tablet: 1, Mobile: 2 }[currentDevice];

	const getFallback = (list, index) => {
		if (list?.[index]) return list[index];
		if (index === 2 && list?.[1] !== '') return list[1];
		if (index === 2 && list?.[0] !== '') return list[0];
		if (index === 1 && list?.[0] !== '') return list[0];
		return '';
	};

	const cssstyle = {
		...wrapperProps?.style,			
		...(width && width[0] !== undefined && width[0] !== null && width[0] !== '' && { width: width[0] + width[1] }),
		...(height && height[0] !== undefined && height[0] !== null && height[0] !== '' && { height: height[0] + height[1] }),	
		...(getFallback(marginTopList, breakPoint) !== '' && { marginTop: getFallback(marginTopList, breakPoint) + 'px' }),	
	}

	const classes = classnames(
		className, ``,			
		{			
		}
	)

	return (
		<BlockListBlock
			{ ...props }
			wrapperProps={ { style : cssstyle } } 	
			className={ classes }
		/>
	)
}


const applyExtraClassSave = (extraProps, blockType, attributes) => {
	
	if (!allowedBlocks.includes(blockType?.name)) {
		return extraProps;
	}

	const { adimension } = attributes;
	if (!adimension) return extraProps;	
	
	const isDifferentFromDefault = JSON.stringify({ ...adimension }) == JSON.stringify({ ...adimensionDefaults });	
	if (isDifferentFromDefault) { return extraProps; }

	const updatedata = {}; 

	for (const key in adimension) {
		const val = adimension[key];
		const def = adimensionDefaults[key];

		if (val === undefined) continue;

		if (JSON.stringify(val) !== JSON.stringify(def) && val !== '') {
			updatedata[key] = val;			
		}
	}

	attributes.adimension = updatedata;
	return extraProps;
};




addFilter(
	'blocks.registerBlockType',
	'aver/adimension-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'aver/adimension-advanced-control',
	addInspectorControl
);

addFilter(
	'editor.BlockListBlock',
	'aver/adimension-editor-class',
	applyExtraClassEditor,
);

addFilter( 
	'blocks.getSaveContent.extraProps',  
	'aver/adimension-save-class',  
	applyExtraClassSave 
);

